const initialState = [];

function devicesReducer(state = initialState, action) {
  switch (action.type) {
    case "devices/update":
      return action.payload;
    default:
      return state;
  }
}

export default devicesReducer;
